<span class="badge" [ngClass]="assessmentStatusClass">
	{{ ScheduledAssessmentStatusLabels[status] }}
</span>
